module.exports = __webpack_public_path__ + "a01aea154d10920a673e6f28de6fa066.jpg";